"use strict";

angular.module("customer")
.controller("SectionInvoiceDetails", function($scope, UserService) {
    $scope.isUserCanPay = false;

    UserService.isUserFetched().then(function onSuccess(user) {
        $scope.isUserCanPay = !!user && user.is_user_can_pay;
    });
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/invoice/invoice-detail.controller.js
// module id = 911
// module chunks = 0